<template>
  <div class="rounded-md bg-green-50 px-4 py-8">
    <div class="flex">
      <div class="flex-shrink-0">
        <svg
          class="h-16 w-16 text-green-400"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
          />
        </svg>
      </div>
      <div class="ml-3">
        <div class="mt-2 text-sm text-green-700">
          <p>
            {{ message }}
          </p>
        </div>
        <div class="mt-4">
          <div class="-mx-2 -my-1.5 flex">
            <!--
            <button
              type="button"
              @click.prevent="$emit('unfinish:chapter')"
              class="bg-red-50 border border-red-200 px-2 py-1.5 rounded-md text-sm font-medium text-red-800 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-red-50 focus:ring-red-600"
              key=""
            >
              "Откатить" результаты
            </button>
            -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div>
    <div class="row">
      <div class="col-lg-2"></div>
      <div class="col-lg-8">
        <div class="card shadow p-3" style="background-color: #dbefff">
          <div class="row">
            <div class="col-2 d-flex">
              <img
                :src="image"
                class="rounded float-left"
                style="width: 100%"
                alt=""
              />
            </div>
            <div class="col-10 my-auto">
              {{ message }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2"></div>
    </div>
  </div> -->
</template>

<script>
export default {
  data() {
    return {
      images: ["winner_ch.svg"],
      image: "",
    };
  },
  props: ["message", "type"],
  mounted() {
    if (this.type == "0") {
      this.image = "/icons/" + this.images[0];
    }
  },
};
</script>